import { useState } from 'react';
import { Modal, Button } from '@/components/common';
import { SignatureCanvas } from './SignatureCanvas';

interface SignatureModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (signature: string) => void;
}

export function SignatureModal({ isOpen, onClose, onConfirm }: SignatureModalProps) {
  const [signature, setSignature] = useState<string | null>(null);

  const handleConfirm = () => {
    if (signature) {
      onConfirm(signature);
      onClose();
    }
  };

  const handleClose = () => {
    setSignature(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Firma del Referidor" size="lg">
      <div className="p-4 space-y-4">
        {/* Privacy notice */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
          <div className="flex gap-2">
            <svg
              className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <div className="text-sm text-blue-700">
              <p className="font-medium mb-1">Aviso de Privacidad</p>
              <p>
                Los datos proporcionados se utilizan únicamente para contacto comercial.
                No vendemos ni compartimos información con terceros.
              </p>
            </div>
          </div>
        </div>

        {/* Signature canvas */}
        <div className="flex justify-center">
          <SignatureCanvas
            onSignatureChange={setSignature}
            width={Math.min(320, window.innerWidth - 64)}
            height={180}
          />
        </div>

        {/* Actions */}
        <div className="flex gap-3 pt-2">
          <Button variant="secondary" onClick={handleClose} className="flex-1">
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!signature}
            className="flex-1"
          >
            Confirmar Firma
          </Button>
        </div>
      </div>
    </Modal>
  );
}
